module.exports = __webpack_public_path__ + "static/media/diktat-30.59925d44.mp3";